import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Filter from "../../Filter";
import {
  doorlockStatusFormatter,
  doorlockBatteryFormatter,
} from "../../../lib/formatter";

import doorlockFormatter from "./DoorlockFormatter";
import CommonModal from "../../../components/CommonModal";
import DoorlockTileDetail from "./DoorlockTileDetail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faCheckCircle,
  faTimesCircle,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
} from "@fortawesome/free-solid-svg-icons";
import MqttDemo from "../mqtt/mqttDemo";
import moment from "moment";

import PinCodeTimeInput from "./PinCodeTimeInput";

const DoorlockTileList = ({
  doorlockListItems,
  buildingListItems,
  floorListItems,
  filterItem,
  detailModal,
  roomDetail,
  checkoutChangeModal,
  logsModal,
  logTypes,
  statusLogs,
  logFilter,
  roomItem,
  mqttModal,
  moveRoomCardKeyModal,
  changeRoomStatusModal,
  moveRoomPinCodeModal,
  data0,
  data1,
  data2,
  data3,
  frameNumber,
  connected,
  setFilterItem,
  handleDetailModalOpen,
  handleDetailModalClose,
  handleLogsModalOpen,
  handleLogsModalClose,
  handleCheckOutChangeModalOpen,
  handleCheckOutChangeModalClose,
  handleFrameCount,
  handleLogFilterChange,
  initLogFilter,
  handleLogsWithCurrentFilter,
  handleForcedOpening,
  handleSetDoorLockTime,
  handleMqttModalOpen,
  handleChangeDoorLockSequenceNumber,
  handleExtensionOfCheckOutTime,
  handleMoveRoomCardKeyModalOpen,
  handleMoveRoomCardKey,
  handleMoveRoomCardKeyModalClose,
  handleMqttModalClose,
  handleChangeRoomStatusModalOpen,
  handleChangeRoomStatusModalClose,
  handleChangeRoomStatus,
  handleMoveRoomPinCodeModalOpen, // 객실 이동 (핀코드)
  handleMoveRoomPinCodeModalClose, // 객실 이동 (핀코드)
  handleMoveRoomPinCode, // 객실 이동 (핀코드)
  handleChangeLockOutPinCode, // 락아웃 (핀코드)
  setData0,
  setData1,
  setData2,
  setData3,
  handleMqttReconnect,
}) => {
  const { t } = useTranslation(); //i18N 다국어 부분 (locales 폴더 참조)

  const statusItems = [
    { key: t("data.doorlock_status.created"), value: "created" },
    { key: t("data.doorlock_status.installed"), value: "installed" },
  ];

  const doorlockTypeItems = [
    { key: t("data.doorlock_type.room"), value: "room" },
    { key: t("data.doorlock_type.commonroom"), value: "commonroom" },
    { key: t("data.doorlock_type.building"), value: "building" },
    { key: t("data.doorlock_type.floor"), value: "floor" },
    { key: t("data.doorlock_type.elevator"), value: "elevator" },
    { key: t("data.doorlock_type.keytag"), value: "keytag" },
  ];

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    if (Object.keys(targetItem).includes("buildingId")) {
      setFilterItem(
        {
          ...filterItem,
          buildingId: targetItem.buildingId,
          floorId: "",
        },
        debounce
      );
    } else {
      setFilterItem(
        {
          ...filterItem,
          ...targetItem,
        },
        debounce
      );
    }
  };

  const initFilterItem = () => {
    setFilterItem({
      buildingId: "",
      floorId: "",
      name: "",
      serial: "",
      type: "",
      status: "",
      fwType: "",
      fwVersion: "",
    });
  };

  //UI 관련 부분 HTML과 유사하게 만들 수 있음.
  return (
    <Fragment>
      <div className="content-title2">
        <h3>{t("content_title.doorlock_list")}</h3>
      </div>
      <div className="content-title">
        {/* 필터 관련 Component */}
        <Filter
          columns={[
            {
              key: "buildingId",
              type: "select",
              size: "xlg",
              placeholder: t("data_column.building"),
              value: filterItem.buildingId,
              action: changeFilterItem,
              selectItems: buildingListItems,
              selectItemKey: "name",
              selectItemValue: "id",
              isRemoveButton: true,
            },
            {
              key: "floorId",
              type: "select",
              size: "md",
              placeholder: t("data_column.floor"),
              value: filterItem.floorId,
              action: changeFilterItem,
              selectItems: floorListItems,
              selectItemKey: "name",
              selectItemValue: "id",
              isRemoveButton: true,
            },
            {
              key: "name",
              size: "md",
              placeholder: t("data_column.doorlock_name"),
              value: filterItem.name,
              action: changeFilterItem,
            },
            {
              key: "serial",
              size: "md",
              placeholder: t("data_column.doorlock_serial"),
              value: filterItem.serial,
              action: changeFilterItem,
            },
            {
              key: "type",
              type: "select",
              size: "xlg",
              placeholder: t("data_column.type"),
              value: filterItem.type,
              action: changeFilterItem,
              selectItems: doorlockTypeItems,
              selectItemKey: "key",
              selectItemValue: "value",
              isRemoveButton: true,
            },
            {
              key: "status",
              type: "select",
              size: "lg",
              placeholder: t("data_column.status"),
              value: filterItem.status,
              action: changeFilterItem,
              selectItems: statusItems,
              selectItemKey: "key",
              selectItemValue: "value",
              isRemoveButton: true,
            },
            {
              key: "fwType",
              type: "select",
              size: "md",
              placeholder: t("data_column.fw_type"),
              value: filterItem.fwType,
              action: changeFilterItem,
              selectItems: doorlockFormatter.fwTypeItems,
              selectItemKey: "key",
              selectItemValue: "value",
              isRemoveButton: true,
            },
            {
              key: "fwVersion",
              size: "xsm",
              placeholder: t("data_column.fw_version"),
              value: filterItem.fwVersion,
              action: changeFilterItem,
            },
          ]}
          init={initFilterItem}
        />
      </div>
      {/* 타일형 관련 부분 시작 */}
      <div className="doorlock-list-card-wrap">
        <div className="doorlock-list-card-body">
          {doorlockListItems.map((doorlock, index) => (
            <div
              className="doorlock-card-wrap"
              key={index}
              onClick={() => handleDetailModalOpen(index)}
            >
              <div className={`doorlock-card-header ${doorlock.status || ""}`}>
                <p className="doorlock-card-header-room">{doorlock.name}</p>
                <p className="doorlock-card-header-keys">
                  <FontAwesomeIcon
                    icon={
                      typeof doorlock.fw_battery === "number" &&
                      doorlock.fw_battery >= 0
                        ? doorlock.fw_battery > 80
                          ? faBatteryFull
                          : doorlock.fw_battery > 30
                          ? faBatteryHalf
                          : faBatteryQuarter
                        : faBatteryEmpty
                    }
                    style={{
                      fontSize: "1.5rem",
                      paddingRight: "3px",
                      color:
                        typeof doorlock.fw_battery === "number" &&
                        doorlock.fw_battery >= 0
                          ? doorlock.fw_battery > 80
                            ? "#4caf50" // 초록색
                            : doorlock.fw_battery > 30
                            ? "#ff9800" // 오렌지색
                            : "#f44336" // 빨간색
                          : "gray",
                    }}
                  />
                </p>
              </div>
              <div className="doorlock-card-content">
                <p>{doorlockStatusFormatter(doorlock.status)}</p>
                <p>
                  <span style={{ fontSize: "0.75rem" }}>
                    {doorlock.type === "commonroom"
                      ? "공용도어"
                      : doorlock.type === "building"
                      ? "빌딩도어"
                      : doorlock.type === "floor"
                      ? "층도어"
                      : doorlock.type === "elevator"
                      ? "엘리베이터"
                      : doorlock.type === "keytag"
                      ? "키택"
                      : doorlock.building_name}
                  </span>
                </p>
                <p>
                  <span style={{ fontSize: "0.75rem" }}>
                    {t("data_column.fw_type")}
                  </span>{" "}
                  : {doorlock.fw_type || "-"}
                </p>
                <p>
                  <span style={{ fontSize: "0.75rem" }}>
                    {t("data_column.fw_version")}
                  </span>{" "}
                  : {doorlock.fw_version || "-"}
                </p>
                <p>
                  <span style={{ fontSize: "0.75rem" }}>
                    {t("data_column.battery_status")}
                  </span>{" "}
                  :{" "}
                  {doorlock.fw_battery > -1
                    ? doorlockBatteryFormatter(doorlock.fw_battery)
                    : "-"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* 도어락 디테일 모달창 영역 */}
      <CommonModal
        show={detailModal}
        size="md"
        title={roomDetail?.name}
        onClose={handleDetailModalClose}
      >
        <div>
          <DoorlockTileDetail
            roomDetail={roomDetail}
            roomItem={roomItem}
            frameNumber={frameNumber}
            connected={connected}
            handleLogsModalOpen={handleLogsModalOpen}
            handleCheckOutChangeModalOpen={handleCheckOutChangeModalOpen}
            handleFrameCount={handleFrameCount}
            handleForcedOpening={handleForcedOpening}
            handleSetDoorLockTime={handleSetDoorLockTime}
            handleChangeDoorLockSequenceNumber={
              handleChangeDoorLockSequenceNumber
            }
            handleMoveRoomCardKeyModalOpen={handleMoveRoomCardKeyModalOpen}
            handleChangeRoomStatusModalOpen={handleChangeRoomStatusModalOpen}
            handleMoveRoomPinCodeModalOpen={handleMoveRoomPinCodeModalOpen}
            handleChangeLockOutPinCode={handleChangeLockOutPinCode}
            handleMqttModalOpen={handleMqttModalOpen}
            handleMqttReconnect={handleMqttReconnect}
          />
        </div>
      </CommonModal>

      {/* 상태로그 / 제어로그 모달창 영역 */}
      <CommonModal
        show={logsModal}
        size="md"
        title={
          logTypes === t("doorlock_detail_modal.status_logd")
            ? t("doorlock_detail_modal.status_logd")
            : t("doorlock_detail_modal.control_logd")
        }
        onClose={handleLogsModalClose}
      >
        <div>
          <Filter
            columns={[
              {
                key: "startAt",
                type: "datePicker",
                placeholder: "시작일자",
                value: logFilter.startAt,
                action: handleLogFilterChange,
                selectsStart: true,
                endDate: logFilter.endAt,
                showTimeSelect: true,
                isRemoveButton: true,
              },
              {
                key: "endAt",
                type: "datePicker",
                placeholder: "종료일자",
                value: logFilter.endAt,
                action: handleLogFilterChange,
                selectsEnd: true,
                startDate: logFilter.startAt,
                showTimeSelect: true,
                isRemoveButton: true,
              },
            ]}
            init={initLogFilter}
          />
          <div style={{ paddingTop: 50 }}>{"로그 데이터"}</div>
          <div
            style={{
              color: "white",
              fontSize: 14,
              background: "#222",
              padding: 24,
              maxHeight: 420,
              overflowY: "auto",
            }}
          >
            {statusLogs.map((log, i) => (
              <div
                key={i}
                style={{
                  marginBottom: 12,
                  borderBottom: "1px solid #333",
                  paddingBottom: 8,
                }}
              >
                <div>
                  [
                  {log.created_at
                    ? moment(log.created_at).format("YYYY/MM/DD HH:mm:ss")
                    : "-"}
                  ]
                </div>
                <div>
                  <b>battery:</b> {log.battery} &nbsp;|&nbsp;
                  <b>control_result:</b> {log.control_result}
                </div>
                <div>
                  <b>created_at:</b>
                  {log.created_at
                    ? moment(log.created_at).format("YYYY/MM/DD HH:mm:ss")
                    : "-"}
                  &nbsp;|&nbsp;
                  <b>frame_number:</b> {log.frame_number}
                </div>
                <div>
                  <b>last_auth_type:</b> {log.last_auth_type} &nbsp;|&nbsp;
                  <b>last_open_type:</b> {log.last_open_type}
                </div>
                <div>
                  <b>lock_state:</b> {log.lock_state} &nbsp;|&nbsp;
                  <b>operating_status:</b> {log.operating_status}
                </div>
                <div>
                  <b>raw_value:</b> {log.raw_value} &nbsp;|&nbsp;
                  <b>rtc_time:</b>
                  {log.rtc_time
                    ? moment(log.rtc_time).format("YYYY/MM/DD HH:mm:ss")
                    : "-"}
                </div>
                <div>
                  <b>special_mode:</b> {log.special_mode} &nbsp;|&nbsp;
                </div>
              </div>
            ))}
          </div>

          <div className="card-foot">
            <div className="form-item-cancel">
              <button
                className="btn-item-cancel"
                onClick={handleLogsModalClose}
              >
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{ paddingRight: "3px" }}
                />
                <span>{t("button.cancel")}</span>
              </button>
            </div>
            <div className="form-item-add center">
              <button
                className="btn-item-add"
                onClick={handleLogsWithCurrentFilter}
              >
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  style={{ paddingRight: "2px" }}
                />
                <span>{t("button.ok")}</span>
              </button>
            </div>
          </div>
        </div>
      </CommonModal>

      {/* 체크아웃 시간 연장 모달창 영역 */}
      <CommonModal
        show={checkoutChangeModal}
        size="md"
        title={t("doorlock_detail_modal.extension_of_check_out_time")}
        onClose={handleCheckOutChangeModalClose}
      >
        <div
          style={{
            padding: 20,
            background: "#23262d",
            color: "#fff",
            borderRadius: 8,
          }}
        >
          <div style={{ marginBottom: 16 }}>
            <div>
              {t("doorlock_detail_modal.extension_of_check_out_time")} :
            </div>
            <div style={{ paddingTop: "30px" }}>
              <input
                className="card-text-input"
                type="number"
                min={1}
                max={32760}
                value={data1}
                onChange={(e) => setData1(e.target.value)}
                placeholder="연장할 시간"
              />
            </div>
          </div>
          <div className="card-foot">
            <div className="form-item-cancel">
              <button
                className="btn-item-cancel"
                onClick={handleCheckOutChangeModalClose}
              >
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{ paddingRight: "3px" }}
                />
                <span>{t("button.cancel")}</span>
              </button>
            </div>
            <div className="form-item-add center">
              <button
                className="btn-item-add"
                onClick={() =>
                  handleExtensionOfCheckOutTime(
                    roomDetail?.dl_serial,
                    roomDetail?.frame_number,
                    roomDetail?.building_index,
                    roomDetail?.floor_index,
                    roomDetail?.room_index
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faSave}
                  style={{ paddingRight: "2px" }}
                />
                <span>{t("button.save")}</span>
              </button>
            </div>
          </div>
        </div>
      </CommonModal>

      {/* 객실 이동 (카드키) 모달창 영역 */}
      <CommonModal
        show={moveRoomCardKeyModal}
        size="md"
        title={t("doorlock_detail_modal.move_room_card_key")}
        onClose={handleMoveRoomCardKeyModalClose}
      >
        <div
          style={{
            padding: 20,
            background: "#23262d",
            color: "#fff",
            borderRadius: 8,
          }}
        >
          <div style={{ marginBottom: 16 }}>
            <div>{t("doorlock_detail_modal.move_room_card_key")} :</div>
            <div style={{ paddingTop: "30px" }}>
              <select
                className="card-text-input"
                value={data3}
                onChange={(e) => {
                  setData3(e.target.value);
                }}
              >
                {doorlockListItems.map((opt) => (
                  <option key={opt.name} value={opt.name}>
                    {opt.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="card-foot">
            <div className="form-item-cancel">
              <button
                className="btn-item-cancel"
                onClick={handleMoveRoomCardKeyModalClose}
              >
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{ paddingRight: "3px" }}
                />
                <span>{t("button.cancel")}</span>
              </button>
            </div>
            <div className="form-item-add center">
              <button
                className="btn-item-add"
                onClick={() => {
                  // name → card_guest_seq_num 변환
                  const selected = doorlockListItems.find(
                    (opt) => opt.card_guest_seq_num === data3
                  );

                  handleMoveRoomCardKey(
                    roomDetail?.dl_serial,
                    roomDetail?.frame_number,
                    roomDetail?.building_index,
                    roomDetail?.floor_index,
                    roomDetail?.room_index,
                    selected?.building_index, // 이게 data0 자리!
                    selected?.floor_index, // 이게 data1 자리!
                    selected?.room_index, // 이게 data2 자리!
                    selected?.card_guest_seq_num // 이게 data3 자리!
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faSave}
                  style={{ paddingRight: "2px" }}
                />
                <span>{t("button.save")}</span>
              </button>
            </div>
          </div>
        </div>
      </CommonModal>

      {/* 객실 상태 변경 모달창 영역 */}
      <CommonModal
        show={changeRoomStatusModal}
        size="md"
        title={t("doorlock_detail_modal.change_room_status")}
        onClose={handleChangeRoomStatusModalClose}
      >
        <div
          style={{
            padding: 20,
            background: "#23262d",
            color: "#fff",
            borderRadius: 8,
          }}
        >
          <div style={{ marginBottom: 16 }}>
            <div>{t("doorlock_detail_modal.change_room_status")} :</div>
            <div style={{ paddingTop: "30px" }}>
              <select
                className="card-text-input"
                value={data0}
                onChange={(e) => setData0(e.target.value)}
              >
                <option value="00">운영 대기</option>
                <option value="01">체크인(입실)</option>
                <option value="02">체크아웃</option>
                <option value="F0">청소 대기</option>
                <option value="F1">청소 중</option>
              </select>
            </div>
          </div>
          <div className="card-foot">
            <div className="form-item-cancel">
              <button
                className="btn-item-cancel"
                onClick={handleChangeRoomStatusModalClose}
              >
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{ paddingRight: "3px" }}
                />
                <span>{t("button.cancel")}</span>
              </button>
            </div>
            <div className="form-item-add center">
              <button
                className="btn-item-add"
                onClick={() => {
                  handleChangeRoomStatus(
                    roomDetail?.dl_serial,
                    roomDetail?.frame_number,
                    roomDetail?.building_index,
                    roomDetail?.floor_index,
                    roomDetail?.room_index
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faSave}
                  style={{ paddingRight: "2px" }}
                />
                <span>{t("button.save")}</span>
              </button>
            </div>
          </div>
        </div>
      </CommonModal>

      {/* 객실 이동 (핀코드) 모달창 영역 */}
      <CommonModal
        show={moveRoomPinCodeModal}
        size="md"
        title={t("doorlock_detail_modal.move_room_pin_code")}
        onClose={handleMoveRoomPinCodeModalClose}
      >
        <div
          style={{
            padding: 20,
            background: "#23262d",
            color: "#fff",
            borderRadius: 8,
          }}
        >
          <div style={{ marginBottom: 16 }}>
            <div>{t("doorlock_detail_modal.move_room_pin_code")} :</div>
            <div style={{ paddingTop: "30px" }}>
              <div>{"도어락 인증 코드"} :</div>

              <input
                className="card-text-input"
                type="number"
                value={data0}
                onChange={(e) => setData0(e.target.value)}
                placeholder="도어락 인증 코드"
              />
            </div>
            <div style={{ paddingTop: "30px" }}>
              <div>{"핀코드"} :</div>

              <input
                className="card-text-input"
                type="number"
                value={data1}
                onChange={(e) => setData1(e.target.value)}
                placeholder="핀코드"
              />
            </div>
            <div>
              <PinCodeTimeInput
                value={data2}
                onChange={setData2}
                label="핀코드 시작 시간"
              />
            </div>
            <div>
              <PinCodeTimeInput
                value={data3}
                onChange={setData3}
                label="핀코드 만료 시간"
              />
            </div>
          </div>
          <div className="card-foot">
            <div className="form-item-cancel">
              <button
                className="btn-item-cancel"
                onClick={handleMoveRoomPinCodeModalClose}
              >
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{ paddingRight: "3px" }}
                />
                <span>{t("button.cancel")}</span>
              </button>
            </div>
            <div className="form-item-add center">
              <button
                className="btn-item-add"
                onClick={() => {
                  handleMoveRoomPinCode(
                    roomDetail?.dl_serial,
                    roomDetail?.frame_number,
                    roomDetail?.building_index,
                    roomDetail?.floor_index,
                    roomDetail?.room_index
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faSave}
                  style={{ paddingRight: "2px" }}
                />
                <span>{t("button.save")}</span>
              </button>
            </div>
          </div>
        </div>
      </CommonModal>

      {/* Mqtt 테스트 모달창 영역 */}
      <CommonModal
        show={mqttModal}
        title={"mqtt 테스트 모달창"}
        size="md"
        onClose={handleMqttModalClose}
      >
        <div>
          <MqttDemo />
        </div>
      </CommonModal>
      {/* 타일형 관련 부분 종료 */}
      {/* <LimitButton
        currentLimit={paginationItem.limit}
        changeLimit={changeLimit}
      />
      <Pagination
        total={doorlockListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      /> */}
    </Fragment>
  );
};

export default DoorlockTileList;
